import React, { useContext } from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"

import ContentfulDataContext from "../context/contentful-data"

const Persons = props => {
  const { allContentfulPerson } = useContext(ContentfulDataContext)

  const gridSize = props.size ? props.size : "medium"

  // Get filter values
  const filter = props.filter ? props.filter.split(":") : ""
  const filterField = filter ? filter[0] : ""
  const filterValues = filter ? filter[1] : ""
  const filterValuesArr = filterValues ? filterValues.split(",") : []

  const filters = filterValuesArr.map(filter => {
    const negative = filter.indexOf("!") === 0
    let filterValue = filter

    if (negative) {
      filterValue = filterValue.substr(1)
    }

    return {
      value: filterValue,
      negative,
    }
  })

  const highlight = props.highlight ? props.highlight.split(":") : ""
  const highlightField = highlight ? highlight[0] : ""
  const highlightValue = highlight ? highlight[1] : ""

  return (
    <div className={`${gridSize}-grid`}>
      {allContentfulPerson.edges.map(({ node: person }) => {
        const pass = []

        // At least one filter condition is met
        for (let i = 0; i < filters.length; i++) {
          const { value: filterValue, negative } = filters[i]

          if (
            !negative &&
            (!person[filterField] ||
              person[filterField].indexOf(filterValue) < 0)
          ) {
            pass.push(0)
          } else if (
            negative &&
            person[filterField] &&
            person[filterField].indexOf(filterValue) > -1
          ) {
            pass.push(0)
          } else {
            pass.push(1)
          }
        }

        // If there's no filter, all persons are listed
        if (filters.length && pass.indexOf(1) < 0) {
          return ""
        }

        const gridCellClass =
          highlightField && person.hasOwnProperty(highlightField)
            ? person[highlightField].indexOf(highlightValue) > -1
              ? `${gridSize}-grid-cell person-role-founder`
              : `${gridSize}-grid-cell`
            : `${gridSize}-grid-cell`

        return (
          <div className={gridCellClass} key={person.slug}>
            <figure className="avatar">
              <Link to={`/team/${person.slug}`}>
                <Img
                  fluid={person.avatarImage.fluid}
                  alt={person.name}
                  title={person.name}
                />
              </Link>
            </figure>
          </div>
        )
      })}
    </div>
  )
}

export default Persons
